import React from 'react';
import classNames from 'classnames';
import './Loader.scss';

export interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  variant?: 'spinner' | 'dots' | 'pulse';
  className?: string;
  fullScreen?: boolean;
}

const Loader: React.FC<LoaderProps> = ({
  size = 'medium',
  variant = 'spinner',
  className,
  fullScreen = false,
}) => {
  const classes = classNames(
    'ui-loader',
    `ui-loader--${variant}`,
    `ui-loader--${size}`,
    {
      'ui-loader--full-screen': fullScreen,
    },
    className
  );

  const renderLoader = () => {
    switch (variant) {
      case 'spinner':
        return <div className="ui-loader__spinner" />;
      case 'dots':
        return (
          <div className="ui-loader__dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        );
      case 'pulse':
        return <div className="ui-loader__pulse" />;
      default:
        return <div className="ui-loader__spinner" />;
    }
  };

  return (
    <div className={classes}>
      {renderLoader()}
    </div>
  );
};

export default Loader;

